/**
 * Utilities for status badge styling and rendering
 */

export type StatusType = 'Publicada' | 'Despublicada' | 'active' | 'inactive';

export interface StatusBadgeConfig {
  backgroundColor: string;
  color: string;
  label: string;
}

/**
 * Get status badge configuration based on status type
 */
export const getStatusBadgeConfig = (status: StatusType): StatusBadgeConfig => {
  const configs: Record<StatusType, StatusBadgeConfig> = {
    'Publicada': {
      backgroundColor: '#10B981',
      color: 'white',
      label: 'Publicada',
    },
    'Despublicada': {
      backgroundColor: '#9CA3AF', 
      color: 'white',
      label: 'Despublicada',
    },
    'active': {
      backgroundColor: '#10B981',
      color: 'white', 
      label: 'Ativo',
    },
    'inactive': {
      backgroundColor: '#9CA3AF',
      color: 'white',
      label: 'Inativo',
    },
  };

  return configs[status] || configs['Despublicada'];
};

/**
 * Generate inline styles for status badge
 */
export const getStatusBadgeStyles = (status: StatusType): React.CSSProperties => {
  const config = getStatusBadgeConfig(status);
  
  return {
    backgroundColor: config.backgroundColor,
    color: config.color,
    fontSize: '12px',
    padding: '6px 12px',
    borderRadius: '12px',
    display: 'inline-block',
    fontWeight: '500',
    textAlign: 'center',
    minWidth: '80px',
  };
};